<template>
  <div class="zu-ct-warp zu-ct-flex" :style="tableCss">
    <div class="zu-ct-header" :style="headerStyle">
      <div class="zu-ct-row">
        <div class="zu-ct-cell" v-for="(item, idx) in config" :key="idx">{{ item.label }}</div>
      </div>
    </div>
    <div class="zu-ct-body">
      <el-form label-width="0" :model="formData" :rules="[]" ref="domains">
        <div class="zu-ct-row" v-for="(item, index) in formData.domains" :key="index">
          <div class="zu-ct-cell" v-for="(child, idx) in config" :key="idx">
            <template v-if="['index'].includes(child.type)">
              <div class="zu-ct-text">{{ index + 1 }}</div>
            </template>
            <template v-if="['text'].includes(child.type)">
              <template v-if="child.prop === 'first_price' && item.stages_mode === '1_2'">
                <el-form-item class="zu-ct-form-item" :prop="`domains.${index}.${child.prop}`" :rules="dynamicNumber">
                  <el-input
                    class="zu-ct-input"
                    size="small"
                    v-model="item[child.prop]"
                    placeholder="请输入"
                    @input="onInputChange($event, child.prop, index)"
                  />
                </el-form-item>
              </template>
              <template v-else>
                <div class="zu-ct-text">{{ item[child.prop] }}</div>
              </template>
            </template>
            <template v-else-if="child.type === 'input'">
              <el-form-item class="zu-ct-form-item" :prop="`domains.${index}.${child.prop}`" :rules="dynamicNumber">
                <el-input
                  class="zu-ct-input"
                  size="small"
                  v-model="item[child.prop]"
                  placeholder="请输入"
                  @input="onInputChange($event, child.prop, index)"
                />
              </el-form-item>
            </template>
            <template v-else-if="child.type === 'select'">
              <template v-if="['stages_mode', 'discount_year'].includes(child.prop)">
                <el-form-item class="zu-ct-form-item" :prop="`domains.${index}.${child.prop}`" :rules="dynamicSelect" v-if="(child.prop === 'stages_mode' && item.isShow) || (child.prop === 'discount_year' && Number(item.discount_price))">
                  <el-select
                    class="zu-ct-select"
                    size="small"
                    v-model="item[child.prop]"
                    :disabled="false"
                    placeholder="请选择"
                    popper-append-to-body
                    @change="onSelectChange($event, child.prop, index)"
                  >
                    <el-option v-for="(option, idx) in (child.options || item.options)" :key="idx" :label="option.label" :value="option.value"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <template v-else>
                <el-select
                  class="zu-ct-select"
                  size="small"
                  v-model="item[child.prop]"
                  :disabled="false"
                  placeholder="请选择"
                  popper-append-to-body
                >
                  <el-option v-for="(option, idx) in (child.options || item.options)" :key="idx" :label="option.label" :value="option.value"></el-option>
                </el-select>
              </template>
            </template>
          </div>
        </div>
        <!-- 底部计算规则 -->
        <div class="zu-ct-row">
          <div class="zu-ct-cell" v-for="(item, index) in bottomTotal" :key="index">
            <div class="zu-ct-text disable">{{ item }}</div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="zu-ct-footer"></div>
  </div>
</template>

<script>
import { preciseAdd, preciseSubtract, preciseDivide, preciseMultiply } from '@/utils'
import { validateNumber } from '@/utils/validate'
export default {
  props: {
    data: {type: Array, default: () => [] },
    config: {type: Array, default: () => [] },
    isDetail: {type: Boolean, default: false },
    border: {type: Boolean, default: true },
    emptyText: {type: String, default: '暂无数据' },
    align: {type: String, default: 'center' },
    headerColor: {type: String, default: '#ffffff' },
    headerBgColor: {type: String, default: '#6B9BFC' },
    headerLineColor: {type: String, default: '#86B0FF' },
    headerStyle: {type: Object, default: () => ({}) },
    color: {type: String, default: '#333333' },
    bgColor: {type: String, default: '#E1EEFF' },
    borderColor: {type: String, default: '#7BB2F4' },
    customStyle: {type: Object, default: () => ({}) },
  },
  watch: {
    data: {
      handler() {
        this.formData.domains = this.changeList()
      },
      immediate: true,
      deep: true
    },
    'formData.domains': {
      handler(val) {
        const arr = val.map(item => {
          const { first_price = 0, average_price = 0, isShow, discount_year, options, ...o } = item
          const obj = { ...o, first_price: Number(first_price) || 0, average_price: Number(average_price) || 0, discount_year: discount_year || 0 }
          return obj
        })
        const obj = {
          goods_stages: arr,
          sum_price: this.bottomTotal[6],
          sum_discount_price: this.bottomTotal[4],
          sum_first_price: this.bottomTotal[7],
          sum_remain_price: preciseSubtract(this.bottomTotal[6], this.bottomTotal[7])
        }
        this.$emit('change', obj)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    tableCss() {
      const justifyContent = {
        center: 'center',
        left: 'flex-start',
        right: 'flex-end'
      }
      const textMap = {
        center: 'center',
        left: 'left',
        right: 'right'
      }
      return {
        '--zu-justify': justifyContent[this.align] || 'center',
        '--zu-align': textMap[this.align] || 'center',
        '--zu-header-line': this.headerLineColor,
        '--zu-header-bg': this.headerBgColor,
        '--zu-header-color': this.headerColor,
        '--zu-border-color': this.borderColor,
        '--zu-body-bg': this.bgColor,
        '--zu-body-color': this.color,
        ...this.customStyle
      }
    },
    bottomTotal() {
      const arr = []
      this.config.forEach((item, i) => {
        if (['index', 'select'].includes(item.type) || ['goods_category_name', 'average_price'].includes(item.prop)) {
          return arr.push(item.prop === 'goods_category_name' ? '合计' : '')
        }
        if (this.isDetail && ['discount_year', 'stages_mode'].includes(item.prop)) return arr.push('')
        const arr2 = this.formData.domains.map(child => child[item.prop])
        const num = arr2.reduce((a,b) => {
          let va = Number(b) || 0
          if (va < 0) va = 0
          return preciseAdd(a, va)
        }, 0)
        arr.push(num)
      })
      return arr
    }
  },
  data() {
    return {
      formData: {
        domains: []
      },
      list: [],
      headers: [],
      dynamicSelect: { required: true, message: '请选择', trigger: 'change' },
      dynamicNumber: { required: true, validator: (_, value, callback) => validateNumber(value, callback, { min: 0, equalToMin: true, empty: '请输入' }), trigger: 'blur' }
    }
  },
  methods: {
    changeList() {
      let arr = []
      if (!this.data.length) return arr
      return JSON.parse(JSON.stringify(this.data))
    },
    onInputChange(value, key, index) {
      let v1 = Number(this.formData.domains[index]['compute_price'])
      let v2 = Number(value) || 0
      if (v2 < 0) v2 = 0
      if (key === 'first_price') {
        let v3 = Number(this.formData.domains[index]['discount_price'])
        let v4 = preciseSubtract(v1, v3)
        if (v2 >= v4) {
          v2 = v4
          this.formData.domains[index]['first_price'] = v2
        }
        this.formData.domains[index]['average_price'] = preciseSubtract(v4, v2)
      } else if (key === 'discount_price') {
        if (v2 >= v1) {
          v2 = v1
          this.formData.domains[index]['discount_price'] = v2
        }
        if (!v2) {
          this.formData.domains[index]['discount_year'] = ''
        }
        let v3 = preciseSubtract(v1, v2)
        this.formData.domains[index]['price'] = v3
        const val1 = this.formData.domains[index]['stages_mode']
        const val2 = val1.split('_')[1]
        const v4 = Number(val2) || 0
        if (!v3) {
          this.formData.domains[index]['first_price'] = v3
          if (!v4) return
          this.formData.domains[index]['average_price'] = v3
          return
        }
        if (v4) {
          let n = preciseDivide(v3, v4)
          const arr = `${n}`.split('.')
          if (arr.length > 1) {
            const m = Number(arr[0])
            const t = preciseMultiply(m, v4)
            const f = preciseAdd(preciseSubtract(v3, t), m)
            this.formData.domains[index]['first_price'] = f
            this.formData.domains[index]['average_price'] = m
            return
          }
          this.formData.domains[index]['first_price'] = n
          this.formData.domains[index]['average_price'] = n
        } else {
          this.formData.domains[index]['first_price'] = v3
          this.formData.domains[index]['average_price'] = ''
        }
      }
    },
    onSelectChange(value, key, index) {
      let c1 = Number(this.formData.domains[index]['compute_price'])
      let c2 = Number(this.formData.domains[index]['discount_price']) || 0
      if (key === 'stages_mode') {
        let v1 = preciseSubtract(c1, c2)
        this.formData.domains[index]['price'] = v1
        const val = value.split('_')[1]
        const v2 = Number(val) || 0
        if (v2) {
          const n = preciseDivide(v1, v2)
          const arr = `${n}`.split('.')
          if (arr.length > 1) {
            const m = Number(arr[0])
            const t = preciseMultiply(m, v2)
            const f = preciseAdd(preciseSubtract(v1, t), m)
            this.formData.domains[index]['first_price'] = f
            this.formData.domains[index]['average_price'] = m
            return
          }
          this.formData.domains[index]['first_price'] = n
          this.formData.domains[index]['average_price'] = n
        } else {
          this.formData.domains[index]['first_price'] = v1
          this.formData.domains[index]['average_price'] = ''
        }
      }
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs['domains'].validate((valid) => {
          if (valid) {
            resolve()
          } else {
            console.log('error submit!!');
            reject()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss"></style>
